import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import http from 'axios';
export default {
  run: function run(session) {
    var oauth = session.oauth;
    http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    http.defaults.baseURL = env('BASE_URL');

    // Add a request interceptor
    http.interceptors.request.use(function (config) {
      // Handle requests here
      config.headers['Authorization'] = oauth.getAuthHeader();
      return config;
    }, function (error) {
      // Do something with request error
      return Promise.reject(error);
    });
    // Add a response interceptor
    http.interceptors.response.use(function (response) {
      // Do something with response data
      return response;
    }, function (error) {
      // Do something with response error
      if (error.response && error.response.status === 401) {
        try {
          oauth.logout();
        } catch (logoutError) {
          // eslint-disable-next-line no-console
          console.error('Logout error:', logoutError);
        }
      }
      return Promise.reject(error);
    });
  }
};